module.exports = __webpack_public_path__ + "static/media/Arrow-Right-Gray-Secondary.9c2de127.svg";